<template>

    <div class="o-box u-bg-color-5">
        <div class="o-box__inner">
            <div class="o-grid -push-1 -grid-no-row-gap -stretch">
                <div class="o-grid-10">
                    <h2 class="o-title-3 o-title-numeric">
                        <span class="o-title-numeric__num" data-content="1"></span>
                        Critères
                    </h2>
                    <div class="o-box__item">
                        <div class="o-form">
                            <div class="o-form-row -col-1/3">
                                <div class="o-form__item">
                                    <div class="o-select__wrap">
                                        <label class="o-label sr-only" for="session">Session</label>
                                       <select id="session" class="o-select" v-model="vSession">
                                            <option value="">Session</option>
                                            <option v-for="s in CompSessions" :key="'s'+s.id" :value="s.id">{{ s.label }}</option>
                                        </select>
                                        <svg class="o-ico -ico-arrow-down" role="img">
                                            <title>arrow-down</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div class="o-form__item">
                                    <div class="o-select__wrap">
                                        <label class="o-label sr-only" for="statut">Statut</label>
                                        <select id="statut" class="o-select" v-model="vStatut">
                                            <option value="">Statut</option>
                                            <option value="1">Étudiant(e) résident(e) du Québec</option>
                                            <option value="2">Étudiant(e) canadien(ne) non-résident(e) du Québec</option>
                                            <option value="3">Étudiant(e) français(e) ou belge francophone</option>
                                            <option value="4">Étudiant(e) international(e)</option>
                                        </select>
                                        <svg class="o-ico -ico-arrow-down" role="img">
                                            <title>arrow-down</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div class="o-form__item">
                                    <div class="o-select__wrap">
                                        <label class="o-label sr-only" for="programme">Programme</label>
                                        <select id="programme" class="o-select" v-model="vClassProgramme">
                                            <option value="">Programme</option>
                                            <option v-for="(p, i) in programmes" :key="'p'+i" :value="p.id">{{ p.label }}</option>
                                        </select>
                                        <svg class="o-ico -ico-arrow-down" role="img">
                                            <title>arrow-down</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div class="o-form__item">
                                    <div class="o-select__wrap">
                                        <label class="o-label sr-only" for="activite">Activité</label>
                                        <select id="activite" class="o-select" v-model="vActivite">
                                            <option value="">Activité</option>
                                            <option v-for="(a, i) in CompActivites" :key="'va'+i" :value="a.id">{{ a.label }}</option>
                                        </select>
                                        <svg class="o-ico -ico-arrow-down" role="img">
                                            <title>arrow-down</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div class="o-form__item">
                                    <div class="o-select__wrap">
                                        <label class="o-label sr-only" for="credits">Crédits</label>
                                        <select id="credits" class="o-select" v-model="vCredits">
                                            <option value="">Crédits</option>
                                            <option v-for="c in CompCredits" :key="'vc'+c" :value="c">{{ c }}</option>
                                        </select>
                                        <svg class="o-ico -ico-arrow-down" role="img">
                                            <title>arrow-down</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div class="o-form__item">
                                    <button class="o-button -calculator-submit -button-bg -block" @click="actionCalculTotal" >
                                        <span class="o-button__icos">
                                            <span class="o-button__ico">
                                                <svg class="o-ico -ico-arrow-full-right" role="img">
                                                    <title>arrow-down</title>
                                                    <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                                </svg>
                                            </span>
                                            <span class="o-button__ico">
                                                <svg class="o-ico -ico-arrow-full-right" role="img">
                                                    <title>arrow-down</title>
                                                    <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                                </svg>
                                            </span>
                                        </span>
                                        <span class="o-button__text__elm">
                                            Calculer
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div class="" v-if="errorMessage !== null">
                                <div class="o-form__item o-form__error">
                                    <h4 class="o-form__error__message">{{ errorMessage }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 class="o-title-3 o-title-numeric">
                        <span class="o-title-numeric__num" data-content="2"></span>
                        Calcul
                    </h2>
                    <div class="o-box__item">
                        <div class="o-table -table-calculator">
                            <table>
                                <tbody>
                                    <tr class="tableauResultat">
                                        <td class="tableauResultat">
                                            <span class="">Droits de scolarité</span>
                                        </td>
                                        <td class="resultat" id="idDroitsScolarite">{{DroitsScolarite}}</td>
                                    </tr>

                                    <tr class="tableauResultat">
                                        <td class="tableauResultat">
                                            <span>Montant forfaitaire additionnel</span>
                                        </td>
                                        <td class="resultat" id="idForfaitaireAdditionnel">{{ ForfaitaireAdditionnel }}</td>
                                    </tr>

                                    <tr class="tableauResultat">
                                        <td class="tableauResultat">
                                            <span>Bourse de stage</span>
                                        </td>
                                        <td class="resultat" id="idBourseStage">{{ BourseStage }}</td>
                                    </tr>

                                    <tr class="tableauResultat">
                                        <td class="tableauResultat">
                                            <span>Assurance maladie et hospitalisation</span>
                                        </td>
                                        <td class="resultat" id="idAssuranceMaladie">{{ AssuranceEtranger }}</td>
                                    </tr>

                                    <tr class="tableauResultat">
                                        <td class="tableauResultat">
                                            <span>Autres frais institutionnels</span>
                                        </td>
                                        <td class="resultat" id="idTotalAutresFrais">{{ TotalAutresFrais }}</td>
                                    </tr>

                                    <tr class="tableauResultat">
                                        <td class="tableauResultat">
                                            <span class=""></span>
                                        </td>
                                        <td class="resultat"></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="tableauResultat">
                                        <td class="tableauResultat">
                                            <span class="Total">Total</span>&nbsp;
                                            <button class="o-button-warning" onclick="document.querySelector('.js-avertissement-calculateur .c-accordion__button').click()">
                                                <svg class="o-ico" role="img">
                                                    <title>warning</title>
                                                    <use xlink:href="/assets/img/sprite.svg?v=2#warning"></use>
                                                </svg>
                                            </button>
                                        </td>
                                        <td class="Total"><span id="idTotal">{{ Total }}</span></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <h2 class="o-title-3 o-title-numeric">
                        <span class="o-title-numeric__num" data-content="3"></span>
                        Messages
                    </h2>
                    <div class="o-box__item">
                        <div class="o-text" v-html="CompMessages"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Calculator',
        props: ['programmes', 'activites', 'messages', 'defaultmessage'],
        data() {
            return {
                calculer: false,
                errorMessage: null,
                vSession: '',
                vStatut: '',
                vClassProgramme: '',
                vActivite: '',
                vCredits: '',
                //TotalAutresFrais: 0,
                Total: '0,00 $',
                DroitsScolarite: '0,00 $',
                ForfaitaireAdditionnel: '0,00 $',
                BourseStage: '0,00 $',
                AssuranceEtranger: '0,00 $',
                TotalAutresFrais: '0,00 $',

                nf: USDollar = new Intl.NumberFormat('fr-CA', {
                    style: 'currency',
                    currency: 'CAD',
                }),

                EnumStatut: {
                    ResidentQuebec: 1,
                    ResidentCanadaNoQc: 2,
                    EtudiantFrancophone: 3,
                    EtudiantEtranger: 4
                },
                EnumClassProgramme: {
                    CheminementUniversitaireTechnologie: 1,
                    ProgrammeCourt1Cycle: 2,
                    Certificat: 3,
                    Baccalauréat: 4,
                    StageRechercheLaboratoire: 5,
                    ProgrammeCourt2Cycle: 6,
                    DESS: 7,
                    MaîtriseProjet: 8,
                    MaîtriseMemoire: 9,
                    Doctorat: 10,
                    ProgrammeLibre: 11,
                    ProgrammeEchange: 12
                },
                EnumActivite: {
                    Cours: 1,
                    StageCooperatif: 2,
                    StageRechercheLaboratoire: 3,
                    StageSTA802MGA902: 4,
                    StageSTA800: 5,
                    CreditsCoursRecherche: 6,
                    CreditsCoursProjet: 7,
                    ACTIVIT: 8,
                    REDACT: 9
                },

                prices: {
                    FraisParCredit: 0,
                    SupplementcanadiensNonResidents: 0,
                    SupplementCycle1CoursAutres: 0,
                    SupplementCycle1CoursSciences: 0,
                    SupplementCycle2: 0,
                    SupplementCycle2Professionnel: 0,
                    SupplementCycle3: 0,
                    FraisBaseSAE: 0,
                    FraisParCreditSAE: 0,
                    FraisAssociationEtudiante: 0,
                    FraisServiceSportTempsPlein: 0,
                    FraisServiceSportTempsPartiel: 0,
                    FraisTechnologiques: 0,
                    FraisDroitsAuteur: 0,
                    MontantActivite: 0,
                    MontantRedaction: 0,
                    SessionActuel: "20241",
                    FraisGeneraux: 0,
                    MontantAssIndividuel: 0,
                    MontantAssFamilial: 0,
                    MontantJournalEtudiant: 0,
                    MontantAssSante: 0,
                    MontantAssDentaire: 0,
                    MontantFraisClubs: 0,
                    MontantFDTempsPlein: 0,
                    MontantFDTempsPartiel: 0,
                    MontantFondDevAEETS: 0
                }
            }
        },
        mounted() {
            const currentYear = new Date().getFullYear();
            this.prices.SessionActuel = currentYear + '1';
            this.updatePrices(this.prices.SessionActuel);
        },
        watch: {
            vSession: function (val) {
                this.updatePrices(val);
            },
        },
        computed: {
            CompActivites() {
                let classProgramme = this.vClassProgramme;
                if (classProgramme === '') return [];
                let programme = this.programmes.filter(p => p.id === classProgramme)[0];
                let activites = this.activites.filter(a => programme.classProgramme.includes(a.id));
                return activites;
            },
            CompCredits() {
                let activite = this.vActivite
                if (activite === '') return [];
                let programme = this.activites.filter(a => a.id === activite)[0];
                return programme.credits
            },
            CompSessions() {
                let sessionActu = this.prices.SessionActuel;
                let Intsession = sessionActu.substring(sessionActu.length - 1, sessionActu.length);
                let AnneeSession = sessionActu.substring(0, sessionActu.length - 1);
                let AnneeSuivante = parseInt(AnneeSession) + 1;
                let MonthNow = parseInt(new Date().getUTCMonth() + 1);   /* Janvier = 0 */
                let sessions = [];

                let Ete = "Été ";
                let Automne = "Automne ";
                let Hiver = "Hiver ";

                if (window.location.href.indexOf('/en/') >= 0) {
                    Ete = "Summer ";
                    Automne = "Fall ";
                    Hiver = "Winter ";
                }
                //les session sont construit a partir de la session actuel mais aussi du mois actuel.
                //On affiche la session actuel et les deux suivante, par contre si la session actuel est deja passé par un mois on affiche la session actuel+1 et le deux suivantes.
                switch (parseInt(Intsession)) {
                    case 1:
                        if (MonthNow > 1) { //Janvier session d'hiver
                            sessions.push({ 'id': AnneeSession + "2", 'label': Ete + AnneeSession });
                            sessions.push({ 'id': AnneeSession + "3", 'label': Automne + AnneeSession });
                            sessions.push({ 'id': AnneeSuivante + "1", 'label': Hiver + AnneeSuivante });
                        } else {
                            sessions.push({ 'id': AnneeSession + "1", 'label': Hiver + AnneeSession });
                            sessions.push({ 'id': AnneeSession + "2", 'label': Ete + AnneeSession });
                            sessions.push({ 'id': AnneeSession + "3", 'label': Automne + AnneeSession });
                        }
                        break;
                    case 2:
                        if (MonthNow > 5) { //Mai session d'Été
                            sessions.push({ 'id': AnneeSession + "3", 'label': Automne + AnneeSession });
                            sessions.push({ 'id': AnneeSuivante + "1", 'label': Hiver + AnneeSuivante });
                            sessions.push({ 'id': AnneeSuivante + "2", 'label': Ete + AnneeSuivante });
                        } else {
                            sessions.push({ 'id': AnneeSession + "2", 'label': Ete + AnneeSession });
                            sessions.push({ 'id': AnneeSession + "3", 'label': Automne + AnneeSession });
                            sessions.push({ 'id': AnneeSuivante + "1", 'label': Hiver + AnneeSuivante });
                        }
                        break;
                    case 3:
                        if (MonthNow > 9) { //Septemer session d'Automne
                            sessions.push({ 'id': AnneeSuivante + "1", 'label': Hiver + AnneeSuivante });
                            sessions.push({ 'id': AnneeSuivante + "2", 'label': Ete + AnneeSuivante });
                            sessions.push({ 'id': AnneeSuivante + "3", 'label': Automne + AnneeSuivante });
                        } else {
                            sessions.push({ 'id': AnneeSession + "3", 'label': Automne + AnneeSession });
                            sessions.push({ 'id': AnneeSuivante + "1", 'label': Hiver + AnneeSuivante });
                            sessions.push({ 'id': AnneeSuivante + "2", 'label': Ete + AnneeSuivante });
                        }
                        break;
                }

                return sessions
            },

            CompMessages() {
                let decodeCriteres = [1, 1, 2, 2, 2], items = [];
                let ListCode = new Array;
                let vSession = this.vSession;
                let vStatut = this.vStatut;
                let vClassProgramme = this.vClassProgramme;
                let vActivite = this.vActivite;
                let vCredit = this.vCredits;
                let vMatch = false;
                let sMessage = this.defaultmessage + '<hr />';
                let bFirst  = true;

                if (!this.calculer) {
                    return this.defaultmessage
                }

                this.messages.forEach((item, index) => {
                    let ColCode = item.code.trim();
                    ListCode = ColCode.split(',');
                    ListCode.forEach((value, key) => {
                        let code = value.trim();
                        let nSession = code.substr(0, decodeCriteres[0]);
                        let nStatut = code.substr(1, decodeCriteres[1]);
                        let nClassProgramme = parseInt(code.substr(2, decodeCriteres[2]));
                        let nActivite = parseInt(code.substr(4, decodeCriteres[3]));
                        let nCredit = parseInt(code.substr(6, decodeCriteres[4]));

                        if (nSession != "X" && nSession != vSession.substr(vSession.length - 1)) { vMatch = false; return; }

                        if (nStatut != "X" && nStatut != vStatut) { vMatch = false; return; }

                        if (nClassProgramme != "XX" && nClassProgramme != vClassProgramme) { vMatch = false; return; }

                        if (nActivite != "XX" && nActivite != vActivite) { vMatch = false; return; }

                        if (nCredit != "XX" && nCredit != vCredit) { vMatch = false; return; }

                        vMatch = true;
                        if (vMatch == true) return false;
                    });

                    if (vMatch == true) {
                        if (bFirst == true) { sMessage = ""; bFirst = false; }
                        sMessage += item.contenu + '<hr />';
                        vMatch = false;
                    }
                });

                return sMessage;
            },
        },
        methods: {
            updatePrices(val) {
                fetch('/api/calculateur/data?Session=' + val, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        this.prices = data.prices
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            },
            actionCalculTotal() {
                if (this.vSession === '' || this.vStatut === '' || this.vClassProgramme === '' || this.vActivite === '' || this.vcredits === '') {
                    this.errorMessage = 'Veuillez sélectionner tous les critères';
                    return;
                } else {
                    this.errorMessage = null;
                }

                this.CalculTotal()
            },

            CalculTotal() {

                let EnumStatut = this.EnumStatut
                let EnumClassProgramme = this.EnumClassProgramme
                let EnumActivite = this.EnumActivite


                let FraisParCredit = this.prices.FraisParCredit
                let FraisMajoreCanadienBelgerancais = this.prices.SupplementcanadiensNonResidents
                let FraisMajoreEtrangerCycle1Autres = this.prices.SupplementCycle1CoursAutres
                let FraisMajoreEtrangerCycle1Sciences = this.SupplementCycle1CoursSciences /*peut servir dans le future*/
                let FraisMajoreEtrangerCycle2 = this.prices.SupplementCycle2
                let FraisSupplementCycle2Professionnel = this.prices.SupplementCycle2Professionnel
                let FraisMajoreEtrangerCycle3 = this.prices.SupplementCycle3
                let FraisParCreditSAE = this.prices.FraisParCreditSAE

                let FraisBaseSAE = this.prices.FraisBaseSAE
                let FraisAssociationEtudiante = this.prices.FraisAssociationEtudiante
                let FraisServiceSportTempsPlein = this.prices.FraisServiceSportTempsPlein
                let FraisServiceSportTempsPartiel = this.prices.FraisServiceSportTempsPartiel
                let FraisTechnologiques = this.prices.FraisTechnologiques
                let FraisDroitsAuteur = this.prices.FraisDroitsAuteur
                let MontantActivite = this.prices.MontantActivite /*peut servir dans le future*/
                let MontantRedaction = this.prices.MontantRedaction /*peut servir dans le future*/
                let MontantAssIndividuel = this.prices.MontantAssIndividuel
                let MontantAssFamilial = this.prices.MontantAssFamilial

                let MontantAssSante = this.prices.MontantAssSante
                let MontantAssDentaire = this.prices.MontantAssDentaire
                let MontantJournalEtudiant = this.prices.MontantJournalEtudiant
                let MontantFraisClubs = this.prices.MontantFraisClubs
                let MontantFDTempsPlein = this.prices.MontantFDTempsPlein
                let MontantFDTempsPartiel = this.prices.MontantFDTempsPartiel
                let MontantFondDevAEETS = this.prices.MontantFondDevAEETS
                let MontantBourseFrancoBaccStage9 = this.prices.MontantBourseFrancoBaccStage9

                let FraisGeneraux = this.prices.FraisGeneraux

                let CalcCreditFraisService = 6
                let vStatut = this.vStatut
                let vClassProgramme = parseInt(this.vClassProgramme)
                let vActivite = this.vActivite
                let vcredit = this.vCredits
                let vSession = this.vSession
                if (EnumClassProgramme.StageRechercheLaboratoire == vClassProgramme) vcredit = 0;

                let DroitsScolarite = 0;
                let ForfaitaireAdditionnel = 0;
                let BourseStage = 0;
                let FraisServiceVieEtudiante = (parseFloat(FraisParCreditSAE) * vcredit) + parseFloat(FraisBaseSAE);
                let BaseCalculeBourseStage = 0;
                let FraisServiceAnimationSportive = 0;
                let SommeFraisTechnologiques = parseFloat((FraisTechnologiques * vcredit));
                let SommeFraisDroitsAuteur = parseFloat((FraisDroitsAuteur * vcredit));
                let AssuranceEtranger = 0;
                let ContributionVolontaire = 0;

                // assurance étranger,  assurance Santé et assurance Dentaire
                if (vSession.substr(-1, 1) == 3) MontantAssIndividuel = MontantAssIndividuel / 3
                else if (vSession.substr(-1, 1) == 1) { MontantAssIndividuel = MontantAssIndividuel / 2; /*MontantAssSante = MontantAssSante / 2; MontantAssDentaire = MontantAssDentaire / 2*/ }

                // Calcule des Contribution Volontaire et les Frais de Service d'Animation Sportive
                if (vcredit < 9) {
                    FraisServiceAnimationSportive = FraisServiceSportTempsPartiel;
                    ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                }
                else {
                    FraisServiceAnimationSportive = FraisServiceSportTempsPlein;
                    ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                }

                // Calcule Droits de scolarité de base
                switch (vClassProgramme) {
                    default:
                        DroitsScolarite = (vcredit * FraisParCredit);
                        break;
                    case EnumClassProgramme.MaîtriseProjet:
                    case EnumClassProgramme.MaîtriseMemoire:
                    case EnumClassProgramme.Doctorat:
                        if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) {
                            DroitsScolarite = MontantRedaction;
                        } else { DroitsScolarite = (vcredit * FraisParCredit); }
                        break;
                    case EnumClassProgramme.StageRechercheLaboratoire:
                    case EnumClassProgramme.ProgrammeEchange:
                        DroitsScolarite = 0;
                        break;
                }

                if (EnumStatut.ResidentQuebec == vStatut) {
                    //alert("ResidentQuebec");
                    switch (vClassProgramme) {

                        case EnumClassProgramme.CheminementUniversitaireTechnologie:
                            ForfaitaireAdditionnel = 0;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeCourt1Cycle:
                            ForfaitaireAdditionnel = 0;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Certificat:
                            ForfaitaireAdditionnel = 0;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Baccalauréat:
                            ForfaitaireAdditionnel = 0;
                            if (vActivite == EnumActivite.StageCooperatif) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; FraisServiceVieEtudiante = (parseFloat(FraisParCreditSAE) * parseInt(CalcCreditFraisService)) + parseFloat(FraisBaseSAE); /*BourseStage = BaseCalculeBourseStage * FraisParCredit;*/ ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire); }                         
                            break;
                        case EnumClassProgramme.StageRechercheLaboratoire:
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0;
                            break;
                        case EnumClassProgramme.ProgrammeCourt2Cycle:
                            ForfaitaireAdditionnel = 0;
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }                        
                            break;
                        case EnumClassProgramme.DESS:
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            ForfaitaireAdditionnel = 0;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.MaîtriseProjet:
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            ForfaitaireAdditionnel = 0;
                            //ForfaitaireAdditionnel = (vActivite != ACTIVIT && vActivite != REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; }
                            if (vActivite == EnumActivite.StageSTA800 || vActivite == EnumActivite.StageSTA802MGA902) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; }
                            break;
                        case EnumClassProgramme.MaîtriseMemoire:
                            ForfaitaireAdditionnel = 0;
                            //ForfaitaireAdditionnel = (vActivite != ACTIVIT && vActivite != REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;                        
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; /*ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);*/ }
                            break;
                        case EnumClassProgramme.Doctorat:
                            //ForfaitaireAdditionnel = 0;
                            //ForfaitaireAdditionnel = (vActivite != ACTIVIT && vActivite != REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;                        
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; /*ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);*/ }
                            break;
                        case EnumClassProgramme.ProgrammeLibre:
                            ForfaitaireAdditionnel = 0;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeEchange:
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0;
                            break;
                        default:
                            ForfaitaireAdditionnel = 0;
                            break;
                    }
                } else if (EnumStatut.EtudiantFrancophone == vStatut) {
                    //alert("EtudiantFrancophone");
                    switch (vClassProgramme) {

                        case EnumClassProgramme.CheminementUniversitaireTechnologie:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeCourt1Cycle:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Certificat:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Baccalauréat:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);

                            if (vActivite == EnumActivite.StageCooperatif) {
                                FraisServiceAnimationSportive = 0;
                                SommeFraisTechnologiques = 0;
                                SommeFraisDroitsAuteur = 0;
                                FraisServiceVieEtudiante = (parseFloat(FraisParCreditSAE) * parseInt(CalcCreditFraisService)) + parseFloat(FraisBaseSAE);
                                BourseStage = (BaseCalculeBourseStage * FraisParCredit) + (BaseCalculeBourseStage * FraisMajoreCanadienBelgerancais);
                                ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire);

                                // if 9 crédit
                                if (vcredit == 9) {
                                    BourseStage = MontantBourseFrancoBaccStage9
                                }
                            }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire); }                       
                            break;
                        case EnumClassProgramme.StageRechercheLaboratoire:
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0;
                            break;
                        case EnumClassProgramme.ProgrammeCourt2Cycle:
                            ForfaitaireAdditionnel = 0;
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            break;
                        case EnumClassProgramme.DESS:
                            ForfaitaireAdditionnel = 0;
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            break;
                        case EnumClassProgramme.MaîtriseProjet:
                            ForfaitaireAdditionnel = (vActivite == EnumActivite.StageSTA800 && vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;                        
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);  

                            if (vActivite == EnumActivite.StageSTA802MGA902 || vActivite == EnumActivite.StageSTA800) {
                                FraisServiceVieEtudiante = (parseFloat(FraisParCreditSAE) * parseInt(CalcCreditFraisService)) + parseFloat(FraisBaseSAE);
                                ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire);
                            /*if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { */FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; /*}*/
                            }
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; }
                            //else if (vActivite == ACTIVIT || vActivite == REDACT) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);};
                            break;
                        case EnumClassProgramme.MaîtriseMemoire:
                            ForfaitaireAdditionnel = /*(vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) :*/ 0;
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            break;
                        case EnumClassProgramme.Doctorat:
                            //ForfaitaireAdditionnel = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;                        
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            break;
                        case EnumClassProgramme.ProgrammeLibre:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeEchange:
                            MontantAssIndividuel = 0;
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0; AssuranceEtranger = MontantAssIndividuel;
                            break;
                        default:
                            ForfaitaireAdditionnel = 0;
                            break;
                    }
                } else if (EnumStatut.ResidentCanadaNoQc == vStatut) {
                    //alert("ResidentCanadaNoQc");
                    switch (vClassProgramme) {

                        case EnumClassProgramme.CheminementUniversitaireTechnologie:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeCourt1Cycle:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Certificat:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Baccalauréat:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);

                            if (vActivite == EnumActivite.StageCooperatif) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; FraisServiceVieEtudiante = (parseFloat(FraisParCreditSAE) * parseInt(CalcCreditFraisService)) + parseFloat(FraisBaseSAE); BourseStage = (BaseCalculeBourseStage * FraisParCredit) + (BaseCalculeBourseStage * FraisMajoreCanadienBelgerancais); ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire); }
                            break;
                        case EnumClassProgramme.StageRechercheLaboratoire:
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0;
                            break;
                        case EnumClassProgramme.ProgrammeCourt2Cycle:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            break;
                        case EnumClassProgramme.DESS:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            break;
                        case EnumClassProgramme.MaîtriseProjet:
                            ForfaitaireAdditionnel = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) : 0;
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; }
                            if (vActivite == EnumActivite.StageSTA800 || vActivite == EnumActivite.StageSTA802MGA902) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; }
                            break;
                        case EnumClassProgramme.MaîtriseMemoire:
                            ForfaitaireAdditionnel = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisMajoreCanadienBelgerancais) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            break;
                        case EnumClassProgramme.Doctorat:
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            break;
                        case EnumClassProgramme.ProgrammeLibre:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreCanadienBelgerancais);
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeEchange:
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0;
                            break;
                        default:
                            ForfaitaireAdditionnel = 0;
                            break;
                    }
                } else {
                    //alert("EtudiantEtranger");
                    switch (vClassProgramme) {

                        case EnumClassProgramme.CheminementUniversitaireTechnologie:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreEtrangerCycle1Autres);
                            AssuranceEtranger = MontantAssIndividuel;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeCourt1Cycle:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreEtrangerCycle1Autres);
                            AssuranceEtranger = MontantAssIndividuel;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Certificat:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreEtrangerCycle1Autres);
                            AssuranceEtranger = MontantAssIndividuel;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.Baccalauréat:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreEtrangerCycle1Autres);

                            if (vActivite == EnumActivite.StageCooperatif) {
                                FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; FraisServiceVieEtudiante = (parseFloat(FraisParCreditSAE) * parseInt(CalcCreditFraisService)) + parseFloat(FraisBaseSAE);
                                BourseStage = ((FraisMajoreEtrangerCycle1Autres * vcredit) - (FraisMajoreCanadienBelgerancais * vcredit)) + ((FraisMajoreCanadienBelgerancais * BaseCalculeBourseStage) + (FraisParCredit * BaseCalculeBourseStage)); ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire);
                            }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssDentaire); } 
                            AssuranceEtranger = MontantAssIndividuel;
                            break;
                        case EnumClassProgramme.StageRechercheLaboratoire:
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0;
                            AssuranceEtranger = MontantAssIndividuel;
                            break;
                        case EnumClassProgramme.ProgrammeCourt2Cycle:
                            ForfaitaireAdditionnel = (vcredit * FraisSupplementCycle2Professionnel);
                            AssuranceEtranger = MontantAssIndividuel;
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            break;
                        case EnumClassProgramme.DESS:
                            ForfaitaireAdditionnel = (vcredit * FraisSupplementCycle2Professionnel);
                            AssuranceEtranger = MontantAssIndividuel;
                            //if (vcredit < 9) { ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            //else { ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }   
                            break;
                        case EnumClassProgramme.MaîtriseProjet:
                            ForfaitaireAdditionnel = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisSupplementCycle2Professionnel) : 0;
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; }
                            if (vActivite == EnumActivite.StageSTA800 || vActivite == EnumActivite.StageSTA802MGA902) { BourseStage = ForfaitaireAdditionnel - (vcredit * FraisMajoreCanadienBelgerancais); FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; }
                            AssuranceEtranger = MontantAssIndividuel;
                            break;
                        case EnumClassProgramme.MaîtriseMemoire:
                            ForfaitaireAdditionnel = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisMajoreEtrangerCycle2) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            AssuranceEtranger = MontantAssIndividuel;
                            break;
                        case EnumClassProgramme.Doctorat:
                            //ForfaitaireAdditionnel = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? (vcredit * FraisMajoreEtrangerCycle3) : 0;
                            //FraisServiceVieEtudiante = (vActivite != EnumActivite.ACTIVIT && vActivite != EnumActivite.REDACT) ? parseFloat((FraisParCreditSAE * vcredit)) : FraisServiceVieEtudiante;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPlein) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            if (vActivite == EnumActivite.ACTIVIT || vActivite == EnumActivite.REDACT) { FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire); }
                            AssuranceEtranger = MontantAssIndividuel;
                            break;
                        case EnumClassProgramme.ProgrammeLibre:
                            ForfaitaireAdditionnel = (vcredit * FraisMajoreEtrangerCycle1Autres);
                            AssuranceEtranger = MontantAssIndividuel;
                            //ContributionVolontaire = parseFloat(MontantFDTempsPartiel) + parseFloat(MontantJournalEtudiant) + parseFloat(MontantFondDevAEETS) + parseFloat(MontantFraisClubs) + parseFloat(MontantAssSante) + parseFloat(MontantAssDentaire);
                            break;
                        case EnumClassProgramme.ProgrammeEchange:
                            ForfaitaireAdditionnel = 0; FraisGeneraux = 0; FraisServiceVieEtudiante = 0; FraisAssociationEtudiante = 0; FraisServiceAnimationSportive = 0; SommeFraisTechnologiques = 0; SommeFraisDroitsAuteur = 0; ContributionVolontaire = 0; AssuranceEtranger = MontantAssIndividuel;
                            break;
                        default:
                            ForfaitaireAdditionnel = 0;
                            break;
                    }
                }

                //var FraisServiceVieEtudiante = parseFloat((FraisParCreditSAE * vcredit)) + parseFloat(FraisBaseSAE);
                ////var FraisServiceAnimationSportive = (vcredit < 12 ? FraisServiceSportTempsPartiel : FraisServiceSportTempsPlein);

                //if ((vcredit <= 3 && vCycle == 1) || vcredit == 0) { FraisServiceAnimationSportive = 0; FraisTechnologiques = 0; FraisDroitsAuteur = 0; }

                //var Fraisfixe = parseFloat(FraisGeneraux) + parseFloat(FraisServiceVieEtudiante) + parseFloat(FraisAssociationEtudiante) + parseFloat(FraisServiceAnimationSportive) + parseFloat((FraisTechnologiques * vcredit)) + parseFloat((FraisDroitsAuteur * vcredit))

                let TotalAutresFrais = parseFloat(FraisGeneraux) + parseFloat(FraisServiceVieEtudiante) + parseFloat(FraisAssociationEtudiante) + parseFloat(FraisServiceAnimationSportive) + parseFloat(SommeFraisTechnologiques) + parseFloat(SommeFraisDroitsAuteur);
                let Total = parseFloat(DroitsScolarite) + parseFloat(ForfaitaireAdditionnel) - parseFloat(BourseStage) + parseFloat(TotalAutresFrais) + parseFloat(AssuranceEtranger) /*+ parseFloat(ContributionVolontaire)*/;
                //var Total = parseFloat(DroitsScolarite) + parseFloat(ForfaitaireAdditionnel)  + parseFloat(TotalAutresFrais) + parseFloat(AssuranceEtranger);
                //alert(parseFloat(FraisGeneraux) + "_" + parseFloat(FraisServiceVieEtudiante) + "_" + parseFloat(FraisAssociationEtudiante) + "_" + parseFloat(FraisServiceAnimationSportive) + "_" + parseFloat(SommeFraisTechnologiques) + "_" +  parseFloat(SommeFraisDroitsAuteur));
                this.DroitsScolarite = this.nf.format(parseFloat(DroitsScolarite).toFixed(2))
                this.ForfaitaireAdditionnel = this.nf.format(parseFloat(ForfaitaireAdditionnel).toFixed(2))
                this.BourseStage = this.nf.format((BourseStage * -1).toFixed(2))
                this.AssuranceEtranger = this.nf.format(parseFloat(AssuranceEtranger).toFixed(2))
                this.TotalAutresFrais = this.nf.format(parseFloat(TotalAutresFrais).toFixed(2))
                this.Total = this.nf.format(parseFloat(Total).toFixed(2))
                this.calculer = true;
                //$("#idDroitsScolarite").html(group1k(parseFloat(DroitsScolarite).toFixed(2)) + ' $');
                //$("#idForfaitaireAdditionnel").html(group1k(parseFloat(ForfaitaireAdditionnel).toFixed(2)) + ' $');
                //$("#idBourseStage").html(group1k((BourseStage * -1).toFixed(2)) + ' $');
                //$("#idAssuranceMaladie").html(group1k(parseFloat(AssuranceEtranger).toFixed(2)) + ' $');
                //$("#idTotalAutresFrais").html(group1k(TotalAutresFrais.toFixed(2)) + ' $');
                //$("#idContributionsVolontaires").html(group1k(ContributionVolontaire.toFixed(2)) + ' $');


                //$("#idTotal").html(group1k(Total.toFixed(2)) + ' $');
            }
        }
    }
</script>